import { api } from '@creditsights/api-ui-web';
import { orderBy } from 'lodash';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,consistent-return
export const fetchCompanySuggestions = async (term) => {
  if (term) {
    const { data: suggestions } = await api.get('common/v1/issuers/suggest_by_term', { params: { term } });
    return suggestions;
  }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchAnalystCoverage = async (analystId) => {
  const { data } = await api.post('common/v1/issuers', { primaryAnalyst: `analyst/${analystId}` });
  return orderBy(data.results, ['displayName'], ['asc']);
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchCompanies = async (searchText, coverage, csView, sort, tags, page = 1) => {
  const { data } = await api.post('common/v1/issuers', {
    skip: (page - 1) * 100,
    take: 100,
    tags,
    coverage,
    recommendationWeightings: csView,
    text: searchText || null,
    sortField: sort.field,
    sortOrderAsc: sort.asc,
  });
  return data;
};
